import React from 'react';
import { Textarea as TextareaShared, ErrorMessage, FormField } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';

export type TextareaProps = {
    id?: string;
    label?: string;
    required?: boolean;
    name: string;
    placeholder?: string;
    testId: string;
};

export const Textarea: React.FC<TextareaProps> = ({ label, name, placeholder, testId, id, required }) => {
    const [field, meta] = useField(name);

    return (
        <FormField
            type="textarea"
            labelForId={id}
            testId={testId}
            labelText={label}
            errorMessage={
                <ErrorMessage id={id} testId={'textarea-error-message'}>
                    {meta.touched && meta.error ? meta.error : ''}
                </ErrorMessage>
            }
        >
            <TextareaShared
                required={required}
                aria-describedby={`error-${id}`}
                id={id}
                placeholder={placeholder}
                {...field}
            />
        </FormField>
    );
};
